import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Lead from '../views/Lead/show.vue'
import EditLead from '../views/Lead/edit.vue'
import NewLead from '../views/Lead/new.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/Lead/:id',
    name: 'Lead',
    component: Lead
  },
  // {
  //   path: '/Leads/new',
  //   name: 'NewLead',
  //   component: NewLead
  // },
  {
    path: '/Leads/:id/edit',
    name: 'EditLead',
    component: EditLead
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  },
    {
    path: '/file-history/:id',
    name: 'FileHistory',
    // route level code-splitting
    // this generates a separate chunk (FileHistory.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "FileHistory" */ '../views/FileHistory.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  base: process.env.BASE_URL,
  routes
})

export default router
